<script>
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from 'svelte';

    import fetchData from '../api.js';
    import UserStore from '../stores/user';

    export let popupMsg = $_('popup.upload_desc');
    export let title = $_('popup.upload_title');

    const dispatch = createEventDispatcher();
    let selectedFile = null;

    function close() {
        dispatch('showUploadPopup', {});
    }

    function handleFileChange(event) {
        selectedFile = event.target.files[0];
    }

    async function uploadFile() {
        if (!selectedFile) {
            alert($_('popup.no_file_selected') || 'No file selected');
            return;
        }

        const postData = {
            action : 'crm_upload_shipments',
            token : $UserStore.data,
            file: selectedFile,
            // other fields if needed
        };

        const result = await fetchData(postData);

        if (result && result.success) {
            alert($_('popup.upload_done') || 'Upload completed successfully');
            location.reload();
        } else {
            alert($_('popup.upload_failed') || 'Upload failed');
        }
    }
</script>


<div class="popup fixed top-0 left-0 m-auto w-full h-full bg-stone-300/[.6] flex items-center justify-center flex-col z-50">
  <div class="bg-white rounded-[5px] px-5 py-5 w-[500px] text-[14px] relative text-center">
    <h4 class="text-[16px] mb-3">{title}</h4>
    <div class="text-center mb-3">
      {@html popupMsg}
    </div>

    <!-- File Input -->
    <div class="text-center mt-2">
      <input type="file" on:change={handleFileChange} class="mb-2" />
    </div>

    <!-- Upload Button -->
    <div
      class="bg-blue-600 text-white rounded-[5px] p-2 mt-2 cursor-pointer text-center"
      on:click={uploadFile}
    >
      {$_('popup.upload_button')}
    </div>

    <!-- Close Button -->
    <div
      class="bg-black text-white rounded-[5px] p-2 mt-2 cursor-pointer text-center"
      on:click={close}
    >
      {$_('status.close')}
    </div>
  </div>
</div>
